export const formatNumber = (
  number: number,
  locale: string,
  options = {} as Intl.NumberFormatOptions,
) => {
  return new Intl.NumberFormat(locale, options).format(number);
};

export const formatPercentage = (
  value: number,
  locale: string,
  options: Omit<Intl.NumberFormatOptions, "style"> = {
    maximumFractionDigits: 2,
  },
) => {
  return Intl.NumberFormat(locale, {
    style: "percent",
    ...options,
  }).format(value);
};
